import React, { useState } from 'react';
import { Sparkles, Check, Copy } from 'lucide-react';

interface HeroVoucherTicketProps {
  onClaim?: () => void;
}

export const HeroVoucherTicket: React.FC<HeroVoucherTicketProps> = ({ onClaim }) => {
  const [copied, setCopied] = useState(false);
  const couponCode = 'FIRSTGLOW';

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(couponCode);
      }
    } catch {
      // Fallback
    }
    localStorage.setItem('blishka_selected_coupon', couponCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2400);
  };

  const handleClaim = () => {
    localStorage.setItem('blishka_selected_coupon', couponCode);
    if (onClaim) {
      onClaim();
    } else {
      const menuEl = document.getElementById('menu');
      if (menuEl) {
        menuEl.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="hero-voucher-ticket-wrapper" aria-label="First Booking Discount Voucher">
      <div
        className="hero-voucher-ticket"
        onClick={handleClaim}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClaim();
          }
        }}
      >
        {/* Subtle shimmer sweep effect */}
        <div className="voucher-shimmer-sweep" aria-hidden="true" />

        {/* ── LEFT TICKET CONTENT (Clean & Punchy) ── */}
        <div className="voucher-main-body">
          <div className="voucher-badge-line">
            <span className="voucher-vip-pill">
              <Sparkles size={10} className="voucher-sparkle-spin" />
              <span>FIRST BOOKING</span>
            </span>
            <span className="voucher-tier-hint">Save ₹50 to ₹250</span>
          </div>

          <div className="voucher-headline-row">
            <h3 className="voucher-main-title">
              Up to <span className="voucher-highlight-gold">₹250 OFF</span>
            </h3>
            <span className="voucher-slabs-inline">
              (₹500→₹50 · ₹850→₹100 · ₹1250→₹150 · ₹1550→₹200 · ₹2150→₹250)
            </span>
          </div>
        </div>

        {/* ── PERFORATED DIVIDER NOTCHES ── */}
        <div className="voucher-perforated-divider" aria-hidden="true">
          <div className="notch-top" />
          <div className="perforated-line" />
          <div className="notch-bottom" />
        </div>

        {/* ── RIGHT TICKET STUB (Tap to copy) ── */}
        <div className="voucher-stub">
          <span className="stub-code-badge">{couponCode}</span>
          <button
            type="button"
            className={`stub-copy-btn ${copied ? 'copied' : ''}`}
            onClick={handleCopy}
            aria-label={`Copy coupon code ${couponCode}`}
          >
            {copied ? (
              <>
                <Check size={11} />
                <span>COPIED!</span>
              </>
            ) : (
              <>
                <Copy size={11} />
                <span>COPY</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
